import {EventEmitter, Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {AuthConfig} from './auth-config';
import {AUTH_CONFIG} from '../../../config/api';
import {LoaderService} from "../../../service/loader.service";
import {PopupComponent} from "../../../shared/popup/popup.component";
import {environment} from "../../../../environments/environment";
import {NavigationService} from "../../../service/navigation.service";
import {MainTabsService} from "../../../service/main-tabs.service";

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    btnLoginText = {
        login: "Login",
        logout: "Logout",
        help: "Help",
        account: "Account"
    };
    activeLoginBtnText = "";

    private config = AUTH_CONFIG;

    // private storage = sessionStorage;
    private storage = localStorage;
    roles: string[];
    rolesObservable = new EventEmitter<any>();
    userLoggedIn = new EventEmitter<any>();

    constructor(@Inject(AuthConfig) private authConfig: AuthConfig,
                private http: HttpClient,
                private navigationService: NavigationService,
                private mainTabsService: MainTabsService,
                private loaderService: LoaderService,
                private popupComponent: PopupComponent
                ) {
        this.resetLoginBtnText();
    }

    isUserLogged() {
        return !!this.storage.getItem('currentUser');
    }

    helpLoginBtnText() {
        this.activeLoginBtnText = this.btnLoginText.help;
    }

    accountLoginBtnText() {
        this.activeLoginBtnText = this.btnLoginText.account;
    }

    resetLoginBtnText() {
        this.activeLoginBtnText = this.isUserLogged() ? this.btnLoginText.logout : this.btnLoginText.login;
    }

    checkPhoneAndSendPin(phone: string, authHash: string){
        this.loaderService.show();
        const body: any = {};
        if (phone) {
            body.phone = phone;
        }
        if (authHash) {
            body.authHash = authHash;
        }
        //console.log('checkPhoneAndSendPin', body);
        // if (environment.frontEndTest) {
        //     body.country = 'us';
        // }
        return this.http.post<any>(this.config.checkPhoneAndSendPin, body);
    }

    register(firstName: string, lastName: string, promoCode: string, password: string, phone: string, pin: string){
        this.loaderService.show();
        //console.log('register', firstName, lastName, promoCode, password, phone, pin);
        return this.http.post<any>(this.config.register, {first_name: firstName, last_name: lastName, promo_code: promoCode, password: password, phone:phone, pin:pin})
          .pipe(map((res: any) => {
            if (res.status) {
                this.setUserLogged(res.result, phone);
                if (res.authHash) {
                    localStorage.setItem('authHash', res.authHash);
                }
            }
            return res;
        }));
    }

    addByPhone(phone:string, firstName: string, lastName: string, password: string, pin: string){
        this.loaderService.show();
        // console.log('addByPhone', firstName, lastName, password, phone, pin);
        return this.http.post<any>(this.config.addByPhone, {phone:phone,firstName, lastName, password: password, pin:pin})
          .pipe(map((res: any) => {
              if (res.status) {
                  this.setUserLogged(res.result, phone);
                  if (res.authHash) {
                      localStorage.setItem('authHash', res.authHash);
                  }
              }
              return res;
          }));
    }

    login(phone: string, pin: string, password: string, code: string, authHash: string) {
        this.loaderService.show();

        let body: any = {
            code: code
        };
        if (phone) {
            body.phone = phone;
        }
        if (password) {
            body.password = password;
        }
        if (pin) {
            body.pin = pin;
        }
        if (authHash) {
          body.authHash = authHash;
        }
        //console.log('login', body);
        // if (environment.frontEndTest) {
        //     body = {
        //         phone: phone,
        //         pin: pin,
        //         country: 'us'
        //     }
        // }

        return this.http.post<any>(this.config.login, body)
          .pipe(map((res: any) => {
              //console.log(res)
              if (res.status) {
                  this.setUserLogged(res.result, phone);
                  if (res.authHash) {
                      localStorage.setItem('authHash', res.authHash);
                  }
              }

              return res;
          }));
    }

    loginAfterReset(phone: string, code: string, password: string) {
        this.loaderService.show();

        let body: any = {};

        if (phone) {
            body.phone = phone;
        }
        if (code) {
            body.pin = code;
        }
        if (password) {
            body.password = password;
        }
        //console.log('loginAfterReset', body);
        // if (environment.frontEndTest) {
        //     body = {
        //         phone: phone,
        //         pin: code,
        //         country: 'us'
        //     }
        // }

        return this.http.post<any>(this.config.loginAfterReset, body)
          .pipe(map((res: any) => {
              //console.log(res)
              if (res.status) {
                  this.setUserLogged(res.result, phone);
                  if (res.authHash) {
                      localStorage.setItem('authHash', res.authHash);
                  }

              }

              return res;
          }));
    }

  loginSendResetCode(phone: string, pin: string){
      this.loaderService.show();
      const body: any = {};
      if (phone) {
        body.phone = phone;
      }
      if (pin) {
        body.pin = pin;
      }
      //console.log('loginSendResetCode', body)
      return this.http.post<any>(this.config.loginSendResetCode, body);
    }

    forgotPassword(phone: string){
        this.loaderService.show();
        const body: any = {};
        if (phone) {
            body.phone = phone;
        }
        //console.log('forgotPassword', body);
        return this.http.post<any>(this.config.forgotPassword, body);
    }

    logoutRequest(){
        return this.http.post<any>(this.config.logout, {});
    }

    setUserLogged(info, phone) {
        this.setCurrentUserPhone(phone);
        this.setData(info);
        this.userLoggedIn.emit(true);
        this.activeLoginBtnText = this.btnLoginText.logout;
    }

    setData(result: string){
        // this.storage = sessionStorage;
        this.storage.setItem('currentUser', JSON.stringify(result));
    }

    async logout() {
        if (this.storage.getItem('currentUser')) {
            this.logoutRequest().toPromise();
        }
        this.storage.removeItem('currentUser');
        //this.storage.clear();
        this.userLoggedIn.emit(false);
        this.activeLoginBtnText = this.btnLoginText.login;

        document.querySelectorAll('.investments-popup').forEach(popup => {
            popup.classList.remove('is-active');
        });
        this.popupComponent.closePopup();
    }


    refreshTokenNow(){
        if (this.storage.getItem('currentUser')) {
            this.http.post<any>(this.config.refresh, {}).subscribe(res => {
                if (res.status) {
                    this.setData(res.result);
                }else{
                    this.mainTabsService.resetActiveTab();
                    this.navigationService.goToHomePage();
                }

                return res;
            });
        }

        return false;
    }

    refreshToken() {
        let $this = this;
        setTimeout(function(){
            $this.refreshToken();
        },60*5*1000);

        this.refreshTokenNow();
    }

    getCurrentUser(){
        if (this.storage.getItem('currentUser')) {
            try {
                const currentUser = JSON.parse(this.storage.getItem('currentUser'));

                return currentUser;
            }catch (e) {

            }
        }

        return false;
    }

    getCurrentUserFirstName(){
        if (this.storage.getItem('currentUser')) {
            try {
                const currentUser = JSON.parse(this.storage.getItem('currentUser'));

                return currentUser.first_name;
            }catch (e) {

            }
        }

        return false;
    }

    getCurrentUserLastName(){
        if (this.storage.getItem('currentUser')) {
            try {
                const currentUser = JSON.parse(this.storage.getItem('currentUser'));

                return currentUser.last_name;
            }catch (e) {

            }
        }

        return false;
    }

    getCurrentUserEmail(){
        if (this.storage.getItem('currentUser')) {
            try {
                const currentUser = JSON.parse(this.storage.getItem('currentUser'));

                return currentUser.email;
            }catch (e) {

            }
        }

        return false;
    }

    setCurrentUserPhone(phone) {
        this.storage.setItem('currentUserPhone', phone);
    }

    getCurrentUserPhone(){
        if (this.storage.getItem('currentUserPhone')) {
            try {
                return JSON.parse(this.storage.getItem('currentUserPhone'));
            }catch (e) {

            }
        }

        return false;
    }
}
